import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVideoOff"><Path d="M17.5512 21.6278L2.1259 1.94727L0.945312 2.87259L1.99826 4.216V20.0002H14.3697L16.3706 22.5532L17.5512 21.6278Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M15.9983 15.2137V17.2149L5.64079 4.00021H15.9983V8.78668L21.9983 5.78668V18.2137L15.9983 15.2137ZM15.9983 13.5367L20.4983 15.7867V8.21373L15.9983 10.4637V13.5367Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideoOff;
